module.exports = __webpack_public_path__ + "media/film_chiara_mia.087e24e5.mp4";